import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function MentionsLegales() {
    const lastUpdate = "28 septembre 2026";

    const sections = [
        {
            id: "editeur",
            title: "Éditeur du site",
            content: [
                "Dénomination : Association Thrundrz",
                "Forme juridique : Association loi 1901",
                "Numéro RNA : W212015924",
                "Siège social : 33 rue d'Auxonne, 21000 Dijon",
                "Email : contact@thrundrz.fr",
                "Responsable de la publication : Sonny Trocard",
            ],
        },
        {
            id: "hebergement",
            title: "Hébergement du site",
            content: [
                "Le site est hébergé par :",
                "Hostinger International Ltd",
                "Adresse : 61 Lordou Vironos Street, 6023 Larnaca, Chypre",
                "Site web : https://www.hostinger.fr",
            ],
        },
        {
            id: "propriete",
            title: "Propriété intellectuelle",
            content:
                "L'ensemble du contenu du site et de l'application (textes, images, logos, icônes, code source) est la propriété exclusive de l'association Thrundrz, sauf mentions contraires. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable. Les visuels et descriptions des événements publiés demeurent la propriété de leurs auteurs respectifs.",
        },
        {
            id: "responsabilite",
            title: "Responsabilité",
            content:
                "Thrundrz agit en qualité d'hébergeur au sens de la loi du 21 juin 2004 pour la confiance dans l'économie numérique. Les informations relatives aux événements sont fournies par les organisateurs, sous leur seule responsabilité. L'association ne saurait être tenue responsable d'éventuelles erreurs, omissions, annulations d'événements ou indisponibilités temporaires du service. Tout contenu illicite peut être signalé à contact@thrundrz.fr ou via la page « Signaler un problème ».",
        },
        {
            id: "rgpd",
            title: "Protection des données personnelles (RGPD)",
            content:
                "Les données collectées via le site et l'application sont destinées à la gestion des comptes utilisateurs, à la publication d'événements et au fonctionnement du service. Conformément au RGPD, l'utilisateur dispose d'un droit d'accès, de rectification, de suppression et de portabilité de ses données en écrivant à contact@thrundrz.fr. Le détail des traitements figure dans notre Politique de confidentialité. En cas de litige, l'utilisateur peut saisir la CNIL via www.cnil.fr.",
        },
        {
            id: "paiements",
            title: "Paiements, billetterie et abonnements",
            content: [
                "Tous les paiements réalisés sur Thrundrz (achat de billets, abonnements) sont traités par Stripe Payments Europe Ltd (1 Grand Canal Street Lower, Dublin 2, Irlande), établissement de monnaie électronique agréé par la Banque centrale d'Irlande et conforme à la norme PCI-DSS.",
                "Aucune donnée de carte bancaire n'est collectée ni conservée par Thrundrz.",
                "Billetterie : les sommes payées par les acheteurs sont conservées sur l'infrastructure sécurisée de Stripe. Thrundrz ne les dépose jamais sur son propre compte bancaire. La part revenant à l'organisateur lui est transférée via Stripe Connect sur son compte de paiement Stripe, puis versée sur son compte bancaire.",
                "Les organisateurs qui vendent des billets ouvrent un compte de paiement auprès de Stripe. Leur identité et leurs coordonnées bancaires sont vérifiées et conservées directement par Stripe, et ne sont pas accessibles à Thrundrz.",
                "Abonnements : l'abonnement est résiliable à tout moment depuis l'espace personnel et prend fin à l'issue de la période en cours.",
            ],
        },
        {
            id: "cookies",
            title: "Cookies",
            content:
                "Le site peut être amené à utiliser des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de fréquentation. Un bandeau d'information est proposé lors de la première navigation, permettant d'accepter ou de refuser les cookies non essentiels.",
        },
        {
            id: "droit",
            title: "Droit applicable",
            content:
                "Les présentes mentions légales sont régies par le droit français. En cas de litige, et après échec d'une résolution amiable, les tribunaux du ressort de Dijon seront seuls compétents.",
        },
    ];

    return (
        <>
            <Helmet>
                <title>Mentions légales — Thrundrz</title>
                <meta
                    name="description"
                    content="Mentions légales de Thrundrz : éditeur, hébergeur, propriété intellectuelle et protection des données."
                />
                <link rel="canonical" href="https://thrundrz.fr/mentions-legales" />
            </Helmet>

            <Navbar />

            <main className="min-h-screen bg-black text-white font-Poppins lg:pt-20 pt-10">
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">

                    {/* En-tête */}
                    <header className="mb-12 text-start">
                        <div className="flex items-center gap-3 mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                fill="currentColor"
                                className="text-color6"
                                viewBox="0 0 16 16"
                            >
                                <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z" />
                                <path d="M3.5 1h.585A1.5 1.5 0 0 0 4 1.5V2a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 12 2v-.5c0-.175-.03-.344-.085-.5H12.5A1.5 1.5 0 0 1 14 2.5v12A1.5 1.5 0 0 1 12.5 16h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1Zm3.5 5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H7Zm-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H7Zm-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H7Zm-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" />
                            </svg>
                            <div>
                                <h1 className="text-3xl sm:text-4xl font-bold text-color6">
                                    Mentions légales
                                </h1>
                            </div>
                        </div>
                        <p className="text-sm sm:text-base text-gray-400 font-thin">
                            Version : {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color6 p-6 shadow-sm font-Poppins bg-[#111]"
                    >
                        <h2 className="text-lg font-semibold text-color6 mb-4">
                            Sommaire
                        </h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-300 hover:text-color6 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color6 mb-4 text-start">
                                    {s.title}
                                </h3>

                                {Array.isArray(s.content) ? (
                                    <ul className="list-disc pl-6 space-y-2 text-gray-200 text-base sm:text-lg">
                                        {s.content.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-gray-200 text-base sm:text-lg leading-relaxed text-justify">
                                        {s.content}
                                    </p>
                                )}
                            </section>
                        ))}
                    </div>

                    <footer className="text-center text-gray-500 text-sm mt-16">
                        © {new Date().getFullYear()} Thrundrz — Tous droits réservés.
                    </footer>
                </div>
            </main>

            <Footer />
        </>
    );
}